import type { UUID } from '@protector/utils/types';
import { Popover } from 'antd';
import { BreadcrumbSeasonsGroup } from 'core/components/header/components/breadcrumb/breadcrumb-seasons.enum';
import { useEffect, useState } from 'react';
import { useMatch, useParams } from 'react-router';
import { useInitialSeasonSelection } from '../use-initial-season-selection.hook';
import { SeasonPopoverTitle } from './season-popover-title.component';
import { SeasonPopover } from './season-popover.component';
import { SeasonPopoverContainer } from './season-popover.style';

export function SeasonPopoverWrapper() {
  const [visible, setVisible] = useState(false);
  const [currentSelected, setCurrentSelected] = useState<UUID | null>(null);
  const { localMode, setLocalMode } = useInitialSeasonSelection({ setCurrentSelected });
  const { propertyId } = useParams();

  useEffect(() => {
    if (propertyId) {
      setLocalMode(BreadcrumbSeasonsGroup.ALL_ACTIVES);
      setCurrentSelected(null);
    }
  }, [propertyId, setLocalMode]);

  const notesMatch = !!useMatch({
    path: '/company/:companyId/property/:propertyId/notes',
    end: false
  });

  const regionalOverviewMatch = !!useMatch({
    path: '/company/:companyId/regional-overview',
    end: false
  });

  const disableSeasonSelector = notesMatch || regionalOverviewMatch;
  return (
    <Popover
      align={{ offset: [0, 8] }}
      placement='bottomLeft'
      content={
        <SeasonPopover
          localMode={localMode}
          close={() => setVisible(false)}
          setLocalMode={setLocalMode}
          setCurrentSelected={setCurrentSelected}
          currentSelected={currentSelected}
        />
      }
      trigger='click'
      open={disableSeasonSelector ? false : visible}
      onOpenChange={setVisible}>
      <SeasonPopoverContainer data-testid='top-bar-season-selector' $disabled={disableSeasonSelector} $active={visible}>
        <SeasonPopoverTitle mode={localMode} selectedSeason={currentSelected} />
      </SeasonPopoverContainer>
    </Popover>
  );
}
